import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Text from "../../Text/Text";
import { Divider, IconButton } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import "../../Pages/page.css"
import {
  hideBuyTermAndCondition,
} from "../../../store/login/action";
import PrivacyPolicy from "../PrivacyPolicy";
import { getCheckboxAgreementTextEditorSelector } from "../../../store/profile/selector";
import CloseIcon from "@material-ui/icons/Close";



const BuyTermAndCondition = (props) => {
  const loginStore = useSelector((state) => state["loginState"]);
  const checkboxAgreementText = useSelector(
    getCheckboxAgreementTextEditorSelector
  );
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(hideBuyTermAndCondition());
  };

  return (
    <>
      <Dialog
        open={loginStore && loginStore.buyTermAndConditionModalYN}
        maxWidth="md"
        fullWidth
      >
        <Grid container xs={12} md={12} spacing={2}>
          <DialogContent className="parkModal">
            <Grid item xs={12} md={12} className="pop-heading">
              <Text variant="h4" className="modHead" style={{ padding: 10,width:'100%'}}>
                Parking rules and regulations
              </Text>

              <IconButton color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon />
              </IconButton>
              <Divider />
            </Grid>
            <Text>
              <b style={{ fontSize: "25px" }}></b>
            </Text>
            <Grid item xs={12} md={12} className="textPadding">
              {checkboxAgreementText && checkboxAgreementText.text != "" ? (
                <div
                  className="ql-editor"
                  style={{ color: "black" }}
                  dangerouslySetInnerHTML={{ __html: checkboxAgreementText }}
                />
              ) : (
                ""
              )}
            </Grid>
          </DialogContent>
        </Grid>
        <DialogActions>
          <Button  onClick={handleClose} color="primary" variant="contained" style={{fontSize:'x-large'}}>
            ok
          </Button>
        </DialogActions>
        <PrivacyPolicy />
      </Dialog>
    </>
  );
};
export default BuyTermAndCondition;
